<template>
  <div class="w-100">
    <div
      class="aib-image"
      :style="rootStyles"
    >
      <div class="aib-image__wrapper">
        <el-image
          :src="src"
          fit="cover"
          :alt="tip"
          class="w-100"
        >
          <template #error>
            <RatioImage 
              src="/static/assets/front-end/img/image-place-holder.png" 
              :ratio="ratio" 
              style="opacity: 0.3;"
              :tip="tip"
            />
          </template>
        </el-image>
        <!-- <img
          :src="imageUrl"
          :alt="tip"
        /> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: null,
  },
  ratio: {
    type: String,
    default: "3:1",
  },
})

/**
 * calc padding-top value
 */
const resolveRatio = (ratio) => {
  const [width, height] = ratio.split(":").map((val) => +val)
  if (!isFinite(width) || !isFinite(height)) {
    throw new Error("ratio must be number,eg. 4:3")
  }

  return Number((height / width) * 100)
}

const rootStyles = computed(() => {
  return {
    paddingTop: `${resolveRatio(props.ratio)}%`,
  }
})
</script>

<style>
.aib-image {
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 75%;
  overflow-x: hidden;
  overflow-y: hidden;
  /* border-radius: 5px; */
}
.aib-image__wrapper {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  min-height: 0;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
.aib-image__wrapper > img,
.aib-image__wrapper .el-image > img {
  object-fit: cover;
  width: 100%;
  /* height: auto; */
  max-width: 100%;
}
</style>
